import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPublicScore } from '../../slices/portfolioSlice';
import {
  Container,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';

export default function EmailCapture() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const tempPortfolio = useSelector((state) => state.portfolio.tempPortfolio);
  const fetchPublicScoreStatus = useSelector((state) => state.portfolio.fetchPublicScoreStatus);
  const fetchPublicScoreError = useSelector((state) => state.portfolio.fetchPublicScoreError);
  
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Redirect if no portfolio data
    if (!tempPortfolio || Object.keys(tempPortfolio).length === 0) {
      navigate('/');
    }
  }, [tempPortfolio, navigate]);

  useEffect(() => {
    // Handle successful score fetch
    if (fetchPublicScoreStatus === 'succeeded') {
      navigate('/score/public');
    }
  }, [fetchPublicScoreStatus, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter an email');
      return;
    }

    if (!tempPortfolio || Object.keys(tempPortfolio).length === 0) {
      setError('No portfolio data found');
      return;
    }

    try {
      await dispatch(fetchPublicScore({
        email,
        portfolio: tempPortfolio
      })).unwrap();
    } catch (err) {
      setError(err.message || 'Failed to get public score');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={2} sx={{ p: { xs: 3, sm: 6 }, textAlign: 'center', borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
            Enter Your Email
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            We'll send your portfolio results and occasional tips.
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
          {fetchPublicScoreError && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {fetchPublicScoreError}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              fullWidth
              type="email"
              label="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={fetchPublicScoreStatus === 'loading'}
              sx={{ mb: 3 }}
              required
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={fetchPublicScoreStatus === 'loading'}
              sx={{ mb: 3, py: 1.5, fontSize: '1rem' }}
            >
              {fetchPublicScoreStatus === 'loading' ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'View My Score'
              )}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}